/* eslint-disable */
const hamburger = document.getElementsByClassName( 'Header-hamburger' )[0];

function toggleMenu() {
  document.querySelector( '.Header' ).classList.toggle( 'Header-open' );
  document.body.classList.toggle( 'no-scroll' );
}

hamburger.addEventListener( 'click', toggleMenu );
